import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useState } from 'react';
import AppointmentService from '../services/appointment-service';
export default function useBookingAppointment() {
  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  var createAppointment = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(baseUrl, calendarTypeId, appointment, guestTimezone) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", AppointmentService.postAppointment(baseUrl, calendarTypeId, appointment, guestTimezone));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createAppointment(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();

  var getAppointment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(appointmentId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return AppointmentService.getOneAppointment(appointmentId);

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getAppointment(_x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getAppointmentsForCalendar = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(appointmentId) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", AppointmentService.getAppointmentsForCalendar(appointmentId));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getAppointmentsForCalendar(_x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateAppointment = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(baseUrl, calendarId, appointmentId, data, timeZone) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return AppointmentService.updateAppointment(baseUrl, calendarId, appointmentId, data, timeZone).then(function (response) {
                return response;
              })["catch"](function (err) {
                return setError(err);
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function updateAppointment(_x7, _x8, _x9, _x10, _x11) {
      return _ref4.apply(this, arguments);
    };
  }();

  var cancelingAppointment = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(appointmentId) {
      var appointment;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return AppointmentService.cancelinkAppointment(appointmentId);

            case 2:
              appointment = _context5.sent;

              if (!appointment.success) {
                _context5.next = 7;
                break;
              }

              return _context5.abrupt("return", appointment.response);

            case 7:
              setError(appointment.response);
              throw appointment.response;

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function cancelingAppointment(_x12) {
      return _ref5.apply(this, arguments);
    };
  }();

  var onFileUploadBucket = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(baseUrl, calendarId, file) {
      var response;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return AppointmentService.onFileUploadBucket(baseUrl, calendarId, file);

            case 2:
              response = _context6.sent;
              return _context6.abrupt("return", response);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function onFileUploadBucket(_x13, _x14, _x15) {
      return _ref6.apply(this, arguments);
    };
  }();

  return {
    createAppointment: createAppointment,
    getAppointment: getAppointment,
    getAppointmentsForCalendar: getAppointmentsForCalendar,
    updateAppointment: updateAppointment,
    cancelingAppointment: cancelingAppointment,
    onFileUploadBucket: onFileUploadBucket,
    error: error
  };
}